
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Ashtavinayakdarshanbusonrent() {



    const cardData =
    {
        keyword: 'Ashtavinayak Darshan Bus On Rent in Pune',
        heading: 'Amruta Travels: Ashtavinayak Darshan Bus On Rent in Pune',
        headingDescription: 'Amruta Travels offers Ashtavinayak Darshan Bus on Rent in Pune, providing a convenient and devotional travel experience to all eight sacred Ganpati temples in Maharashtra. Whether you’re planning a family pilgrimage or group yatra, our clean, comfortable, and well-maintained buses ensure a smooth and spiritually enriching journey. With experienced drivers familiar with all Ashtavinayak routes, flexible scheduling, and 24/7 support, Amruta Travels makes your religious tour safe, timely, and stress-free.',


        top: 'Top Places to Visit in Outstation Pune with Amruta Travels',


  "topPlaces": [
    {
      "title": "Mahabaleshwar",
      "description": "Located around 120 km from Pune, Mahabaleshwar is a picturesque hill station in the Western Ghats, known for its cool climate, evergreen forests, and stunning viewpoints such as Arthur’s Seat, Wilson Point (the highest point), and Kate's Point. The region is famous for its strawberry farms, especially during the Strawberry Festival held in spring. Other attractions include Venna Lake for boating, Mapro Garden for strawberry-based treats, and ancient temples like Panchganga and Mahabaleshwar Temple. It's a popular destination for families, honeymooners, and nature enthusiasts seeking a refreshing escape from city life."
    },
    {
      "title": "Lonavala & Khandala",
      "description": "Just 66 km from Pune, these twin hill stations in the Sahyadri range offer a perfect blend of natural beauty and adventure. Lonavala is known for its misty mountains, lush greenery, and monsoon waterfalls like Kune and Bhivpuri. Attractions include Bhushi Dam, Tiger’s Leap, Rajmachi Fort, and Karla & Bhaja Caves. Khandala is equally famous for its panoramic valley views and trekking routes. The area is ideal for a weekend drive, with scenic routes and roadside chikki stalls that add to the charm of this quick getaway."
    },
    {
      "title": "Shirdi",
      "description": "About 190 km from Pune, Shirdi is a sacred town revered by followers of Sai Baba. The Sai Baba Samadhi Mandir is the main attraction, drawing millions of devotees every year. Pilgrims can also visit Dwarkamai, Chavadi, and the Sai Heritage Village. The spiritual ambiance, combined with well-maintained infrastructure and religious events, makes Shirdi a prominent destination for those seeking peace, healing, and spiritual growth."
    },
    {
      "title": "Goa",
      "description": "Located nearly 450 km from Pune, Goa is India’s premier beach destination, known for its lively culture, golden beaches, and Portuguese heritage. From North Goa’s party hotspots like Baga, Anjuna, and Calangute to South Goa’s serene stretches like Palolem and Colva, there’s a vibe for every traveler. Apart from beaches, visitors can explore Aguada Fort, Basilica of Bom Jesus, spice plantations, vibrant flea markets, and indulge in thrilling water sports. Goa is also a haven for foodies, offering authentic seafood, Goan curries, and beachside shacks serving refreshing cocktails."
    },
    {
      "title": "Nashik",
      "description": "Around 210 km from Pune, Nashik is a city of immense cultural, historical, and spiritual significance. It is one of the four cities where the Kumbh Mela is held. Attractions include the ancient Kalaram Temple, Muktidham Temple, Pandavleni Caves, and Trimbakeshwar Temple—an important Jyotirlinga. Nashik is also the wine capital of India, home to Sula Vineyards, York Winery, and many tasting tours. The Godavari River adds to its charm, making it a harmonious blend of spirituality and leisure tourism."
    },
    {
      "title": "Alibaug",
      "description": "Situated about 140 km from Pune, Alibaug is a tranquil coastal town offering a perfect mix of beaches, history, and nature. Popular beaches include Nagaon, Alibaug Beach, and Kashid Beach, all great for swimming, sunbathing, and water sports. The iconic Kolaba Fort, accessible during low tide, adds historical value to the destination. You can also explore Korlai Fort, Kanakeshwar Temple, and local seafood cuisine. Ideal for weekend trips, Alibaug also offers ferry services from Mumbai for added convenience."
    },
    {
      "title": "Kolhapur",
      "description": "Roughly 235 km from Pune, Kolhapur is a vibrant city known for its divine Mahalaxmi Temple, which draws pilgrims throughout the year. The city is equally famous for its spicy cuisine, Kolhapuri chappals, and traditional arts. Attractions include Rankala Lake for evening strolls, Panhala Fort offering panoramic views, and the New Palace Museum showcasing royal heritage. With its rich cultural identity and warm hospitality, Kolhapur is ideal for heritage and culinary tourism."
    },
    {
      "title": "Lavasa",
      "description": "Just 60 km from Pune, Lavasa is an Italian-inspired planned city nestled in the Sahyadri hills. It features beautiful waterfronts, European-style architecture, and a peaceful atmosphere perfect for a quick weekend escape. Activities include kayaking, zip-lining, and lakeside cycling. With cozy resorts, conference centers, and nature trails, Lavasa attracts both families and corporate travelers. The weather remains pleasant most of the year, enhancing its appeal as a rejuvenating destination close to Pune."
    },
    {
      "title": "Satara & Kaas Plateau",
      "description": "About 120 km from Pune, Satara serves as the base for exploring the Kaas Plateau—popularly known as the 'Valley of Flowers' of Maharashtra. The plateau, a UNESCO World Natural Heritage site, bursts into a riot of colors with over 850 species of wildflowers during the monsoon season. Satara is also known for Ajinkyatara Fort, Thoseghar Waterfalls, and Sajjangad Fort. The natural beauty and biodiversity make this region a paradise for trekkers, botanists, and photographers."
    },
    {
      "title": "Aurangabad",
      "description": "Situated 235 km from Pune, Aurangabad is a historical treasure trove, offering insights into ancient art, architecture, and culture. The city is home to the world-famous Ajanta and Ellora Caves, adorned with exquisite carvings and paintings dating back to 2nd century BCE. Other attractions include Bibi Ka Maqbara (a replica of the Taj Mahal), Daulatabad Fort, and Aurangabad Caves. The city is also a gateway to Grishneshwar Jyotirlinga and Paithani saree shopping, making it a must-visit for heritage lovers."
    }
  ],

    "services": [
    {
      "name": "Ashtavinayak Bus Hire Pune",
      "description": "Take a divine journey with our Ashtavinayak Bus Hire services from Pune. Our buses are well-maintained, comfortable, and equipped with modern amenities to ensure a safe and pleasant pilgrimage to the Ashtavinayak temples."
    },
    {
      "name": "AC Bus for Ashtavinayak Darshan",
      "description": "Travel in comfort with our AC buses for Ashtavinayak Darshan. These buses are designed to provide a cool, comfortable, and peaceful journey as you visit the eight sacred Ganesh temples of Ashtavinayak."
    },
    {
      "name": "25, 32, 35, 40, 50 Seater Bus Hire for Ashtavinayak",
      "description": "Choose from our variety of bus sizes (25, 32, 35, 40, and 50-seaters) to accommodate your group for the Ashtavinayak Darshan. Whether you're traveling with a small family or a large group, we have the right size bus for your needs."
    },
    {
      "name": "Pune to Ashtavinayak Tour by Bus",
      "description": "Embark on a complete Ashtavinayak tour from Pune with our dedicated bus hire services. We provide a comfortable, hassle-free journey to all the eight Ganesh temples, with professional drivers and modern amenities to ensure a smooth experience."
    },
    {
      "name": "Ashtavinayak Yatra Volvo Bus Pune",
      "description": "For a luxurious pilgrimage experience, opt for our Ashtavinayak Yatra Volvo bus services. With top-tier amenities, spacious seating, and air-conditioning, your journey to the Ashtavinayak temples will be comfortable and serene."
    },
    {
      "name": "Bharat Benz Bus for Ganpati Tour",
      "description": "Choose our Bharat Benz bus services for a luxurious Ganpati tour. These buses provide unmatched comfort, reliability, and are perfect for long-distance travel to the Ashtavinayak temples."
    },
    {
      "name": "Luxury AC Bus for Ashtavinayak Yatra",
      "description": "Travel in luxury to the Ashtavinayak temples with our luxury AC buses. We offer well-maintained, fully air-conditioned buses with modern amenities, ensuring that your pilgrimage journey is both comfortable and memorable."
    },
    {
      "name": "One Day Ashtavinayak Bus Pune",
      "description": "Book a one-day Ashtavinayak Darshan bus from Pune for a quick and convenient pilgrimage tour. Our buses are ideal for those looking to complete the Ashtavinayak journey in a day, with comfortable seating and experienced drivers."
    },
    {
      "name": "Pune Pilgrimage Bus Rental",
      "description": "Rent a bus from Pune for your pilgrimage to the Ashtavinayak temples. We offer a variety of buses that can be customized for your group’s needs, ensuring that your religious trip is comfortable and hassle-free."
    },
    {
      "name": "Ganesh Darshan Bus Hire",
      "description": "Our Ganesh Darshan Bus Hire service takes you on a divine journey to the Ashtavinayak temples. With air-conditioned buses, comfortable seating, and experienced drivers, you can enjoy a peaceful and safe journey."
    },
    {
      "name": "Group Tour Ashtavinayak Bus Pune",
      "description": "Take your group on a memorable Ashtavinayak tour with our specialized group bus hire services. We offer buses of various sizes and ensure a comfortable, smooth journey to the eight sacred temples of Lord Ganesha."
    },
    {
      "name": "AC Coach Hire Ashtavinayak",
      "description": "For a luxurious and comfortable pilgrimage experience, hire an AC coach for your Ashtavinayak Darshan. Our coaches come with modern amenities and spacious seating to ensure a pleasant and hassle-free journey."
    },
    {
      "name": "Pune to Ganpati Temple Tour Bus",
      "description": "Join our Pune to Ganpati Temple Tour with dedicated bus hire services for Ashtavinayak Darshan. Our buses are ideal for both small and large groups, providing comfortable travel to the Ganesh temples in and around Pune."
    },
    {
      "name": "Family Bus Hire for Ashtavinayak Tour",
      "description": "Rent a family-friendly bus for your Ashtavinayak tour. Our buses are perfect for family groups, offering spacious seating, AC comfort, and a safe, peaceful journey to the eight Ganesh temples."
    },
    {
      "name": "Ashtavinayak Round Trip Bus Rental",
      "description": "Book our Ashtavinayak round-trip bus rental services for a convenient and affordable pilgrimage experience. Whether you're looking for a one-day trip or a longer journey, we provide comfortable buses for your Ashtavinayak Yatra."
    }
  ],
  "tableData": [
    ["Ashtavinayak Bus Hire Pune", "AC Bus for Ashtavinayak Darshan"],
    ["25, 32, 35, 40, 50 Seater Bus Hire for Ashtavinayak", "Pune to Ashtavinayak Tour by Bus"],
    ["Ashtavinayak Yatra Volvo Bus Pune", "Bharat Benz Bus for Ganpati Tour"],
    ["Luxury AC Bus for Ashtavinayak Yatra", "One Day Ashtavinayak Bus Pune"],
    ["Pune Pilgrimage Bus Rental", "Ganesh Darshan Bus Hire"],
    ["Group Tour Ashtavinayak Bus Pune", "AC Coach Hire Ashtavinayak"],
    ["Pune to Ganpati Temple Tour Bus", "Family Bus Hire for Ashtavinayak Tour"],
    ["Ashtavinayak Round Trip Bus Rental"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Ashtavinayak Darshan Bus on Rent in Pune",
    "WhyChoosedescription": "Amruta Travels offers convenient and comfortable bus rentals for the Ashtavinayak Darshan tour from Pune. Whether you are planning a family trip, a religious pilgrimage, or a group visit, our buses ensure a safe, reliable, and comfortable journey to the sacred Ashtavinayak temples."
  },
  {
    "WhyChooseheading": "Comfortable and Air-Conditioned Travel for Pilgrims",
    "WhyChoosedescription": "Our buses are equipped with air-conditioning, spacious seating, and ample legroom, making your Ashtavinayak Darshan tour both comfortable and relaxing. Enjoy a smooth, peaceful ride while traveling to all eight of the Ashtavinayak temples."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Safe and Timely Pilgrimages",
    "WhyChoosedescription": "Our drivers are well-trained, experienced, and knowledgeable about the Ashtavinayak route. They ensure that you and your group reach each temple safely and on time, while maintaining a respectful and professional attitude throughout the journey."
  },
  {
    "WhyChooseheading": "Ideal for Group Pilgrimages and Religious Tours",
    "WhyChoosedescription": "The Ashtavinayak Darshan tour is ideal for religious groups, families, and friends. Our buses are designed to accommodate large groups comfortably, ensuring that your entire family or group can travel together and share this sacred experience."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing for Pilgrims",
    "WhyChoosedescription": "We offer competitive, transparent pricing for Ashtavinayak Darshan bus rentals. Our all-inclusive rates cover fuel, tolls, driver allowances, taxes, and more, ensuring no hidden fees or surprises as you plan your religious journey."
  },
  {
    "WhyChooseheading": "Well-Maintained Buses for a Safe and Comfortable Journey",
    "WhyChoosedescription": "Our buses are regularly maintained and thoroughly inspected to ensure that your journey is smooth and safe. We prioritize the comfort and safety of our passengers, so you can focus on your spiritual experience while we handle the travel details."
  },
  {
    "WhyChooseheading": "A Peaceful and Spiritual Environment for Pilgrims",
    "WhyChoosedescription": "We understand the importance of a peaceful and comfortable journey for your pilgrimage. Our buses are equipped with clean interiors, comfortable seating, and a serene environment, allowing you to relax and prepare for your spiritual journey to the Ashtavinayak temples."
  },
  {
    "WhyChooseheading": "Easy Booking and 24/7 Customer Support",
    "WhyChoosedescription": "Booking an Ashtavinayak Darshan bus with Amruta Travels is quick and easy. You can book online, by phone, or visit our office in Pune. Our 24/7 customer support team is available to assist with bookings, itinerary changes, or any special requests you may have."
  }
]






















    }

const faqData = [
  {
    question: 'Can I hire a bus for Ashtavinayak Darshan from Pune with Amruta Travels?',
    answer: 'Yes, Amruta Travels offers buses for hire for the Ashtavinayak Darshan from Pune. Our buses are perfect for large groups and provide a comfortable, safe, and enjoyable pilgrimage experience to all the Ashtavinayak temples.',
  },
  {
    question: 'What amenities are available in the bus for Ashtavinayak Darshan?',
    answer: 'Our buses for the Ashtavinayak Darshan are equipped with comfortable seating, air conditioning, entertainment options, ample legroom, overhead storage, and clean, hygienic interiors. We ensure a comfortable journey for you and your group.',
  },
  {
    question: 'Is the Ashtavinayak Darshan bus available for both local and outstation travel?',
    answer: 'Yes, the bus is available for both local travel in Pune as well as for outstation travel to the Ashtavinayak temples. We ensure a safe and hassle-free journey to all the eight sacred Ganesh temples.',
  },
  {
    question: 'Is a driver included in the Ashtavinayak Darshan bus rental?',
    answer: 'Yes, all our Ashtavinayak Darshan buses come with an experienced and professional driver, familiar with the route and the temples, ensuring a smooth and timely pilgrimage experience.',
  },
  {
    question: 'How much does it cost to hire a bus for Ashtavinayak Darshan from Pune?',
    answer: 'The cost of hiring a bus for Ashtavinayak Darshan depends on factors such as the type of bus, distance, and duration of the trip. Rates typically start from ₹40–₹50 per km. Please contact us with your itinerary for a customized quote.',
  },
  {
    question: 'Is the bus comfortable for long journeys during the Ashtavinayak Darshan?',
    answer: 'Yes, the buses we provide for Ashtavinayak Darshan are designed for long journeys, offering comfortable seating, air conditioning, and ample space for both passengers and luggage, making it an ideal choice for your pilgrimage trip.',
  },
  {
    question: 'Are the buses for Ashtavinayak Darshan well-maintained and sanitized?',
    answer: 'Absolutely. All our buses are regularly maintained, thoroughly cleaned, and sanitized before every trip to ensure passenger safety, hygiene, and comfort.',
  },
  {
    question: 'How do I book a bus for Ashtavinayak Darshan in Pune?',
    answer: 'You can easily book a bus for Ashtavinayak Darshan through our website or by contacting our customer support team. We offer quick booking assistance and customized packages for your convenience.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Ramesh Patil',
    role: 'Pilgrimage Tour Coordinator, Pune',
    text: 'We hired a bus from Amruta Travels for our Ashtavinayak Darshan. The bus was very comfortable, and the driver was experienced and knowledgeable about the route. The journey was smooth and enjoyable, and we had a great time visiting all the temples. Highly recommend Amruta Travels!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Pratima Agarwal',
    role: 'Religious Tour Planner',
    text: 'I booked a bus for Ashtavinayak Darshan with Amruta Travels. The bus was clean, spacious, and air-conditioned, which made the long journey comfortable. The trip was well-organized, and we had an excellent experience visiting all the temples. Very pleased with the service!',
    rating: 5,
  },
];






























































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Ashtavinayak Darshan Bus On Rent in Pune",
  "image": "https://bushireinpune.com/assets/images/ashtavinayak-darshan-bus-pune.jpg",
  "description": "Amruta Travels offers Ashtavinayak Darshan Bus on Rent in Pune for a comfortable and luxurious pilgrimage to the Ashtavinayak temples. Choose from 25, 32, 35, 40, or 50-seater AC buses, including Volvo and Bharat Benz, for a safe, hassle-free journey to the Ganesh temples. Book your Ashtavinayak Yatra now for a memorable family trip or group tour.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "1600"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "9500",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/ashtavinayak-darshan-bus-rent-pune"
  }
};







    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | Ashtavinayak Darshan Bus On Rent in Pune | AC Coach for Ganesh Yatra</title>
  <meta 
    name="description" 
    content="Book a comfortable Ashtavinayak Darshan bus on rent in Pune for a group or family pilgrimage tour. Choose from 25, 32, 40, or 50-seater AC buses including Volvo and Bharat Benz for a memorable Ganesh Yatra." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/61.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Ashtavinayakdarshanbusonrent;